import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  masterdata: [],
  totalCount: 0,
};

const fetchStart = (state) => {
  state.isLoading = true;
  state.error = null;
};

const fetchSuccess = (state, action) => {
  state.isLoading = false;
  state.error = null;
  state.masterdata = action.payload;
};

const fetchFailure = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const addStart = fetchStart;

const addSuccess = (state, action) => {
  state.masterdata = Array.isArray(state.masterdata)
    ? [...state.masterdata, action.payload]
    : [action.payload];
  state.isLoading = false;
  state.totalCount += 1;
};

const addFailure = fetchFailure;

const deleteStart = fetchStart;

const deleteSuccess = (state, action) => {
  state.isLoading = false;
  state.masterdata = Array.isArray(state.masterdata)
    ? state.masterdata.filter((item) => item.master_id !== action.payload)
    : [];
  state.error = null;
};

const deleteFailure = fetchFailure;
const masterSlice = createSlice({
  name: "master",
  initialState,
  reducers: {
    // Fetch actions
    fetchDescriptionStart: fetchStart,
    fetchDescriptionSuccess: fetchSuccess,
    fetchDescriptionFailure: fetchFailure,

    fetchEndsStart: fetchStart,
    fetchEndsSuccess: fetchSuccess,
    fetchEndsFailure: fetchFailure,

    fetchInspectionLocStart: fetchStart,
    fetchInspectionLocSuccess: fetchSuccess,
    fetchInspectionLocFailure: fetchFailure,

    fetchManufacturerStart: fetchStart,
    fetchManufacturerSuccess: fetchSuccess,
    fetchManufacturerFailure: fetchFailure,

    fetchSizeStart: fetchStart,
    fetchSizeSuccess: fetchSuccess,
    fetchSizeFailure: fetchFailure,

    fetchSurfaceStart: fetchStart,
    fetchSurfaceSuccess: fetchSuccess,
    fetchSurfaceFailure: fetchFailure,

    fetchTypeStart: fetchStart,
    fetchTypeSuccess: fetchSuccess,
    fetchTypeFailure: fetchFailure,

    fetchWelderStart: fetchStart,
    fetchWelderSuccess: fetchSuccess,
    fetchWelderFailure: fetchFailure,

    // Add actions
    addDescriptionStart: addStart,
    addDescriptionSuccess: addSuccess,
    addDescriptionFailure: addFailure,

    addEndsStart: addStart,
    addEndsSuccess: addSuccess,
    addEndsFailure: addFailure,

    addInspectionLocStart: addStart,
    addInspectionLocSuccess: addSuccess,
    addInspectionLocFailure: addFailure,

    addManufacturerStart: addStart,
    addManufacturerSuccess: addSuccess,
    addManufacturerFailure: addFailure,

    addSizeStart: addStart,
    addSizeSuccess: addSuccess,
    addSizeFailure: addFailure,

    addSurfaceStart: addStart,
    addSurfaceSuccess: addSuccess,
    addSurfaceFailure: addFailure,

    addTypeStart: addStart,
    addTypeSuccess: addSuccess,
    addTypeFailure: addFailure,

    addWelderStart: addStart,
    addWelderSuccess: addSuccess,
    addWelderFailure: addFailure,

    // Delete actions
    deleteDescriptionStart: deleteStart,
    deleteDescriptionSuccess: deleteSuccess,
    deleteDescriptionFailure: deleteFailure,

    deleteEndsStart: deleteStart,
    deleteEndsSuccess: deleteSuccess,
    deleteEndsFailure: deleteFailure,

    deleteInspectionLocStart: deleteStart,
    deleteInspectionLocSuccess: deleteSuccess,
    deleteInspectionLocFailure: deleteFailure,

    deleteManufacturerStart: deleteStart,
    deleteManufacturerSuccess: deleteSuccess,
    deleteManufacturerFailure: deleteFailure,

    deleteSizeStart: deleteStart,
    deleteSizeSuccess: deleteSuccess,
    deleteSizeFailure: deleteFailure,

    deleteSurfaceStart: deleteStart,
    deleteSurfaceSuccess: deleteSuccess,
    deleteSurfaceFailure: deleteFailure,

    deleteTypeStart: deleteStart,
    deleteTypeSuccess: deleteSuccess,
    deleteTypeFailure: deleteFailure,

    deleteWelderStart: deleteStart,
    deleteWelderSuccess: deleteSuccess,
    deleteWelderFailure: deleteFailure,

    // Edit actions
    editDescriptionStart: fetchStart,
    editDescriptionSuccess(state, action) {
      state.isLoading = false;
      state.masterdata = action.payload;
    },
    editDescriptionFailure: fetchFailure,
  },
});

export const {
  fetchDescriptionStart,
  fetchDescriptionSuccess,
  fetchDescriptionFailure,
  fetchEndsStart,
  fetchEndsSuccess,
  fetchEndsFailure,
  fetchInspectionLocStart,
  fetchInspectionLocSuccess,
  fetchInspectionLocFailure,
  fetchManufacturerStart,
  fetchManufacturerSuccess,
  fetchManufacturerFailure,
  fetchSizeStart,
  fetchSizeSuccess,
  fetchSizeFailure,
  fetchSurfaceStart,
  fetchSurfaceSuccess,
  fetchSurfaceFailure,
  fetchTypeStart,
  fetchTypeSuccess,
  fetchTypeFailure,
  fetchWelderStart,
  fetchWelderSuccess,
  fetchWelderFailure,
  addDescriptionStart,
  addDescriptionSuccess,
  addDescriptionFailure,
  addEndsStart,
  addEndsSuccess,
  addEndsFailure,
  addInspectionLocStart,
  addInspectionLocSuccess,
  addInspectionLocFailure,
  addManufacturerStart,
  addManufacturerSuccess,
  addManufacturerFailure,
  addSizeStart,
  addSizeSuccess,
  addSizeFailure,
  addSurfaceStart,
  addSurfaceSuccess,
  addSurfaceFailure,
  addTypeStart,
  addTypeSuccess,
  addTypeFailure,
  addWelderStart,
  addWelderSuccess,
  addWelderFailure,
  deleteDescriptionStart,
  deleteDescriptionSuccess,
  deleteDescriptionFailure,
  deleteEndsStart,
  deleteEndsSuccess,
  deleteEndsFailure,
  deleteInspectionLocStart,
  deleteInspectionLocSuccess,
  deleteInspectionLocFailure,
  deleteManufacturerStart,
  deleteManufacturerSuccess,
  deleteManufacturerFailure,
  deleteSizeStart,
  deleteSizeSuccess,
  deleteSizeFailure,
  deleteSurfaceStart,
  deleteSurfaceSuccess,
  deleteSurfaceFailure,
  deleteTypeStart,
  deleteTypeSuccess,
  deleteTypeFailure,
  deleteWelderStart,
  deleteWelderSuccess,
  deleteWelderFailure,
  editDescriptionStart,
  editDescriptionSuccess,
  editDescriptionFailure,
} = masterSlice.actions;

export default masterSlice.reducer;
